import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { ArrowIcon } from 'assets';
import * as S from './styled';

interface BackButtonProps {
  text: string;
  fallbackUrl?: string;
  onClick?: () => void;
  color?: string;
}

const BackButton = ({ text, fallbackUrl, color = '', onClick, ...rest }: BackButtonProps) => {
  const navigate = useNavigate();
  /* const location = useLocation(); */

  const handleClick = useCallback(() => {
    if (!fallbackUrl) return;

    navigate(fallbackUrl, { replace: true });

    /* else if (location.key !== 'default') {
      navigate(-1);
    } else {
      navigate('/auth/onboarding', { replace: true });
    } */
  }, [navigate, fallbackUrl]); /* location.key */

  return (
    <S.BackLink onClick={onClick || handleClick} {...rest}>
      <ArrowIcon color={color} />
      <S.LinkText color={color}>{text}</S.LinkText>
    </S.BackLink>
  );
};

export default BackButton;
